export default {
  props: {
    file: File,
  },
  data() {
    return {
      id: this.$options.name,
      previewIconClass: "",
      previewIconSrc: "",
    };
  },
  created() {
    this.getFileType();
  },
  methods: {
    getFileType() {
      if (this.file.type.includes("image")) {
        //is image
        //set class for image
        this.previewIconClass = `${this.id}__image`;

        //set blob
        this.previewIconSrc = URL.createObjectURL(this.file);
      } else {
        //is document
        //set class for doc
        this.previewIconClass = `${this.id}__doc`;

        //set icon based on extension

        this.previewIconSrc = `./img/fileicons/small${this.file.type.substring(
          this.file.type.indexOf("/")
        )}.svg`;
      }
    },
  },
};
